import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

export const SEO = ({ title, description }) => {
  const location = useLocation();
  const defaultTitle = "Nuestra Visión TV / Intelite";
  const defaultDescription =
    "Escucha cada mañana el resumen informativo en formato podcast: análisis y contexto de los temas que marcan la agenda en México.";
  const defaultCanonical = "https://www.elmediodemedios.com";

  return (
    <Helmet>
      <title>{title ? `${defaultTitle} | ${title}` : defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <link
        rel="canonical"
        href={`${defaultCanonical}${location.pathname}`}
      />

      <meta property="og:title" content={title || defaultTitle} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta
        property="og:url"
        content={`${defaultCanonical}${location.pathname}`}
      />
      <meta
        property="og:image"
        content={`${defaultCanonical}/logo_mdm_nv.png`}
      />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Nuestra Visión TV / Intelite",
          url: defaultCanonical,
          logo: `${defaultCanonical}/logo_mdm_nv.png`,
        })}
      </script>
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonical: PropTypes.string,
};
